import { signal } from "@preact/signals-react"

export const appConfigSignal = signal(null)
export const appConfigErrorSignal = signal(null)
export const appConfigLoadedSignal = signal(false)